import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'

export function useAutoAssignAgentEnabled(): boolean {
  /* eslint-disable-next-line @github-ui/github-monorepo/no-use-feature-flags --
     TODO: Migrate to isFeatureEnabled from @github-ui/feature-flags. See
     https://thehub.github.com/epd/engineering/dev-practicals/frontend/react/data-router/migration/app-payload-deprecation/ */
  return useFeatureFlag('memex_autopilot')
}
